module.exports = __webpack_public_path__ + "static/media/35_A.2d7365eb.png";